import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import VueClipboard from 'vue-clipboard2';
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
let default_1 = class default_1 extends Vue {
    copyStr;
    // 复制成功时的回调函数
    onCopy() {
        this.$message.success(`${this.$t('copySuccess')}`);
    }
    // 复制失败时的回调函数
    onError() {
        this.$message.error(`${this.$t('copyFail')}`);
    }
};
__decorate([
    Prop()
], default_1.prototype, "copyStr", void 0);
default_1 = __decorate([
    Component({
        name: 'copy-button',
        i18n: {
            messages: {
                zh: {
                    copySuccess: '复制成功！',
                    copyFail: '复制失败!',
                },
                en: {
                    copySuccess: 'Copy successfully!',
                    copyFail: 'Copy failed!',
                }
            }
        }
    })
], default_1);
export default default_1;
